import TheLayout from "@/components/TheLayout.vue";
import IsPc from "../utils/isPC";
const isPC = IsPc();

const allRoutes = [
  {
    path: "/",
    name: "TheLayout",
    component: TheLayout,
    redirect: { name: "HomePage" },
    children: [
      {
        path: "",
        name: "HomePage",
        component: () => import("@/views/Home/Index.vue"),
        meta: {
          title: "人才码头 - 针对职场人提供专业的人才评估服务",
        },
      },
    ],
  },
  {
    path: "/company/login",
    name: "companyLogin",
    component: () => import("@/views/AuthLogin.vue"),
    meta: {
      title: "企业登录 - 人才码头",
    },
  },
  {
    path: "/school/login",
    name: "schoolLogin",
    component: () => import("@/views/AuthLogin.vue"),
    meta: {
      title: "院校登录 - 人才码头",
    },
  },
  {
    path: "/trial",
    name: "applyTrial",
    component: () => import("@/views/ApplyTrial.vue"),
    m_component: () => import("@/views/ApplyTrialH5.vue"),
    meta: {
      title: "申请试用 - 人才码头",
    },
  },
  {
    path: "/bind/company/:code",
    name: "bindCompany",
    component: () => import("@/views/BindCompany.vue"),
    meta: {
      title: "申请试用 - 人才码头",
    },
  },
].map((route) => {
  const judgeH5Route = (item: any) => {
    if (!isPC && item.m_component) {
      Object.assign(item, { component: item.m_component });
    }
    if (item.children && typeof item.children === "object") {
      Object.assign(item, {
        children: item.children.map(function (child: any) {
          return judgeH5Route(child);
        }),
      });
    }
    return item;
  };
  return judgeH5Route(route);
});

export default allRoutes;
